"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.23 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zm.88 13.75h-1.75V14h1.75v1.75zm.38-4.04c-.03.04-.06.09-.09.14-.02.04-.05.08-.07.12-.03.05-.05.1-.07.15-.02.04-.04.08-.05.13-.06.19-.1.4-.1.63h-1.76c0-.36.04-.66.11-.93h.02v-.06c.51-1.76 2.36-1.86 2.48-3.24.07-.85-.53-1.67-1.36-1.85-.91-.2-1.74.33-2.03 1.12-.11.33-.4.58-.76.58h-.16c-.55 0-.93-.53-.76-1.05.5-1.58 2.09-2.68 3.89-2.4 1.52.23 2.72 1.53 2.92 3.05.27 1.99-1.42 2.51-2.21 3.61z"
})), 'NotListedLocationRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/NotListedLocationRounded.js
// module id = 4340
// module chunks = 0